import CardRow from '../../components/CardRow/CardRow';
import CardRowCard from '../../components/CardRow/CardRowCard';
import React from 'react';
import TransactionsList from './components/TransactionsList';
import SectionHeader from '../../components/SectionHeader/SectionHeader';
import { FormattedMessage } from 'react-intl';
import useBreadCrumbs from '../../hooks/breadCrumbs/useBreadCrumbs';

const TransactionsListPage = () => {
  useBreadCrumbs(<FormattedMessage id={'app.transactions.label'} />);
  return (
    <React.Fragment>
      <SectionHeader>
        <FormattedMessage id={'app.transactions.label'} />
      </SectionHeader>
      <CardRow>
        <CardRowCard>
          <TransactionsList />
        </CardRowCard>
      </CardRow>
    </React.Fragment>
  );
};

export default TransactionsListPage;
